import Styles, { Close, Content, Heading, Message } from './css'
import React from 'react'
import { ReactComponent as CloseIcon } from '@icons/close.svg'
import { ReactComponent as CheckIcon } from '@icons/check.svg'
import { ReactComponent as AlertIcon } from '@icons/alert.svg'

export interface NotificationProps {
    heading?: string,
    icon?: React.ReactNode,
    message: string,
    type?: "error" | "info",
    onClose: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

const Notification: React.FC<NotificationProps> = ({ icon = <CheckIcon />, heading, message, type, onClose }) => {
    if (type === "error") icon = <AlertIcon />
    if (type === "info") icon = <AlertIcon />
    const modifiers = { type }
    return (
        <Styles {...modifiers}>
            <Close onClick={onClose}><CloseIcon /></Close>
            <Content>
                {icon}
                <div>
                    {heading && <Heading>{heading}</Heading>}
                    <Message>{message}</Message>
                </div>
            </Content>
        </Styles>
    )
}

export default Notification